module.exports = __webpack_public_path__ + "img/story031@2x.cd1cf097.webp";